import Vue from "vue";
const state = Vue.observable({
  client_na: "",
  client_sub: "",
  client_cd: "",
  client_cd_hyphen: "",
  client_na_disp: "",
  siten_name: "",
  client_mail:"",
  ndnetjoin_fg: "",
  ndnetuid_di: "",
  dukubun: "",
  recordCount: "",
  countAdmin: "1",
  eyeColor: "#969394"
});

export const mutations = Vue.observable({});

export const getters = Vue.observable({
  items: () => state
});

export const actions = Vue.observable({
  async getRandomPW() {
    const xSid = "ConfirmPassword";
    const xSno = "randomPW";
    const apiParameters = {};
    const response = await this.postAsteria(xSid, xSno, apiParameters);
    return response;
  },
  async authList() {
    const xSid = "ConfirmPassword";
    const xSno = "authList";
    const apiParameters = {};
    const response = await this.postAsteria(xSid, xSno, apiParameters);
    return response;
  },
  /**
   * 氏名
   */
  nameCheck(name) {
    var err_msg = "";
    var reg = new RegExp(/<|>/);

    if (name == "" || name == null) {
      err_msg = "・【氏名】を入力してください。";
      return err_msg;
    } else if (reg.test(name)) {
      err_msg = "・【氏名】入力文字に「<」「>」は使用できません。";
      return err_msg;
    } else {
      return "0";
    }
  },

  loginIdCheck(id) {
    var err_msg = "";
    var reg = new RegExp(/^[a-zA-Z0-9_\-\.]+@[a-zA-Z0-9\-\.]+$/);

    if (id == "" || id == null) {
      err_msg = "・【ログインID】を入力してください。";
      return err_msg;
    } else if (!reg.test(id)) {
      err_msg =
        "・【ログインID】@を含む半角英数記号で入力してください。";
      return err_msg;
    } else {
      return "0";
    }
  },
  emailCheck(email) {
    var err_msg = "";
    var reg = new RegExp(/^[a-zA-Z0-9_\-\.]+@[a-zA-Z0-9\-\.]+$/);

    if (email == "" || email == null) {
      err_msg = "・【メールアドレス】を入力してください。";
      return err_msg;
    } else if (!reg.test(email)) {
      err_msg =
      "・【メールアドレス】@を含む半角英数記号で入力してください。";
      return err_msg;
    } else {
      return "0";
    }
  },
  roleCheck(role) {
    var err_msg = "";
    if (role == "" || role == null) {
      err_msg = "・【権限】を選択してください。";
      return err_msg;
    } else {
      return "0";
    }
  },
  pwCheck(pw) {
    var err_msg = "";
    var reg = new RegExp(/[^a-zA-Z0-9\.\-@_]/);
    if (pw == "" || pw == null) {
      err_msg = "・【パスワード】を入力してください。";
      return err_msg;
    } else if (pw.length < 8) {
      err_msg = "・【パスワード】8文字以上の半角英数字で入力してください。";
      return err_msg;
    } else if (reg.test(pw)) {
      err_msg = "・【パスワード】8文字以上の半角英数字で入力してください。";
      return err_msg;
    } else {
      return "0";
    }
  },
  maildtCheck(date) {
    var err_msg = "";
    var reg = new RegExp(/^(19|20)\d\d[/](0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])$/);
    var parts = [];
    parts = date.split('/');
    var chkFlag = false;
    var chkToday = false;
    if(parts.length == 3){
      chkFlag = this.chkValidDate(parts[0], parts[1], parts[2]);
      chkToday = this.biggerThanToday(parts[0], parts[1], parts[2]);
    }

    if (date == "" || date == null) {
      err_msg = "・【案内メール送信予定日】を入力してください。";
      return err_msg;
    } else if(!reg.test(date)) {
      err_msg = "・【案内メール送信予定日】yyyy/mm/dd形式で入力してください。";
      return err_msg;
    }else if(!chkFlag) {
      err_msg = "・【案内メール送信予定日】日付に誤りがあります。例）2020/02/30";
      return err_msg;
    }else if(!chkToday){
      err_msg = "・【案内メール送信予定日】当日以降の日付のみ入力してください。";
      return err_msg;
    }else {
      return "0"
    }
  },
  startdtCheck(date) {
    var err_msg = "";
    var reg = new RegExp(/^(19|20)\d\d[/](0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])$/);
    var parts = [];
    parts = date.split('/');
    var chkFlag = false;
    var chkToday = false;
    if(parts.length == 3){
      chkFlag = this.chkValidDate(parts[0], parts[1], parts[2]);
      chkToday = this.biggerThanToday(parts[0], parts[1], parts[2]);
    }

    if (date == "" || date == null) {
      err_msg = "・【利用開始日】を入力してください。";
      return err_msg;
    } else if(!reg.test(date)) {
      err_msg = "・【利用開始日】yyyy/mm/dd形式で入力してください。";
      return err_msg;
    }else if(!chkFlag) {
      err_msg = "・【利用開始日】日付に誤りがあります。例）2020/02/30";
      return err_msg;
    }else if(!chkToday){
      err_msg = "・【利用開始日】当日以降の日付のみ入力してください。";
      return err_msg;
    }else {
      return "0"
    }
  },
  chkValidDate(year, month, day){
    var chkDate = new Date(year, month-1, day);
    if(chkDate.getFullYear() == year && chkDate.getMonth()+1 == month && chkDate.getDate() == day){
      return true;
    }else{
      return false;
    }
  },
  biggerThanToday(year, month, day){
    var chkDate = new Date(year, month-1, day);
    var today = new Date();
    if(chkDate.getTime() > today.getTime()){
      return true;
    }else {
      return false;
    }
  },
  hoverEye(){
    this.items.eyeColor = "#545253";
  },
  unhoverEye(){
    this.items.eyeColor = "#969394";
  },
  onCopy: function(e) {
    alert(e.text + "以上をクリップボードにコピーしました。");
  },
  onError: function() {
    alert("コピーに失敗しました");
  },
  message(item) {
    let content =
      "得意先名：" +
      this.items.client_na +
      "\n" +
      "得意先CD：" +
      this.items.client_cd_hyphen +
      "\n" +
      "ユーザ名：" +
      item.tantousya_name +
      "\n" +
      "ユーザID：" +
      item.tantousya +
      "\n" +
      "\n" +
      "パスワード：" +
      item.password +
      "\n";
    return content;
  },
  roleDisableChk(userRole){
    if(this.items.countAdmin=='1' && userRole=='1'){
      return true;
    }else{
      return false;
    }
  }
});
